module.exports = __webpack_public_path__ + "static/media/excel_logo_login.b99d7b61.jpg";